import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]

import VueScrollTo from 'vue-scrollto';

import { onMounted, ref, watch } from 'vue';
import type { UseScrollReturn } from '@vueuse/core';
import { vScroll } from '@vueuse/components';
import { useScrollStore } from '@/stores/useScrollStore';

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollPagination',
  props: {
    scrollId: {},
    maxHeight: {},
    isLoading: { type: Boolean },
    isPageEnd: { type: Boolean }
  },
  emits: ['next-page', 'page-end'],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;

const scrollStore = useScrollStore();




const isNoMorePaginationResult = ref(false);
const pageNumber = ref(1);
const isDisabledNextPage = ref(false);

watch(() => props.isPageEnd, (val) => {
  if (val) {
    emit('page-end');
    isNoMorePaginationResult.value = true;
    scrollStore.setScrollEnd(true);
  } else {
    isNoMorePaginationResult.value = false;
    scrollStore.setScrollEnd(false);
  }
});
watch(() => props.isLoading, (val) => {
  if (!val) {
    isDisabledNextPage.value = false;
  }
});

onMounted(() => {
  if (!props.isPageEnd) {
    return;
  }
  isNoMorePaginationResult.value = props.isPageEnd;
  scrollStore.setScrollEnd(true);
  emit('page-end');
});

function onScroll(state: UseScrollReturn) {
  const { isScrolling, arrivedState, directions } = state;
  if (isScrolling.value && directions.bottom === false) {
    return;
  }
  if (isNoMorePaginationResult.value) {
    scrollStore.setScrollEnd(true);
    return;
  }
  if (arrivedState.bottom && !isDisabledNextPage.value) {
    pageNumber.value++;
    isDisabledNextPage.value = true;
    emit('next-page', pageNumber.value);
  }
}
function resetPageNumber() {
  pageNumber.value = 1;
  VueScrollTo.scrollTo(`#${props.scrollId}`, 200, {
    container: `#${props.scrollId}`,
    easing: 'ease-in',
  });
}

__expose({ resetPageNumber });

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: _ctx.scrollId,
    class: "relative w-min min-w-full h-full overflow-y-auto",
    style: _normalizeStyle({
      maxHeight: _ctx.maxHeight
    })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 12, _hoisted_1)), [
    [_unref(vScroll), [onScroll, {
      offset: {
        bottom: 400,
      },
    }]]
  ])
}
}

})